export const APP_LOCALE_TYPE_LIST = ['ko'] as const;
export type AppLocaleType = (typeof APP_LOCALE_TYPE_LIST)[number];
